import callApi from 'utils/callApi';

// Requests
export function requestFetchClaimFillingCodes({ limit, offset }) {
  return callApi('resource/claim_filling_code/search/', 'POST', {
    limit,
    offset,
  });
}

export function requestSearchClaimFillingCodes({ limit, offset, filters }) {
  return callApi('resource/claim_filling_code/search/', 'POST', {
    filters,
    sort_by: [
      {
        name: 'Full Name',
        sort: 'asc',
      },
      {
        name: 'ID',
        sort: 'asc',
      },
    ],
    limit,
    offset,
  });
}



// WEBPACK FOOTER //
// ./src/redux/modules/claimFillingCodes.js